import { PageToolbar } from '@app/components/page-toolbar/PageToolbar';
import { Box, Skeleton } from '@mui/material';
import { PageTabsSkeleton } from './PageTabsSkeleton';

interface PageHeaderSkeletonProps {
  breadcrumbs?: number;
  tabs?: number;
}

/**
 * Page header placeholder that mirrors the same vertical structure as PageHeader.
 */
export function PageHeaderSkeleton({ breadcrumbs, tabs }: PageHeaderSkeletonProps) {
  const breadcrumbsCount = breadcrumbs ?? 0;
  const tabsCount = tabs ?? 0;
  const hasBreadcrumbs = breadcrumbsCount > 0;
  const hasTabs = tabsCount > 0;

  return (
    <PageToolbar
      id="page-header-skeleton"
      sx={{
        pb: hasTabs ? 0 : 1.25,
      }}
    >
      {hasBreadcrumbs && (
        <Box
          display="flex"
          alignItems="center"
          columnGap={1}
          rowGap={0.5}
          flexWrap="wrap"
          minHeight="24px"
        >
          {Array.from({ length: breadcrumbsCount }, (_, index) => (
            <Skeleton
              key={`breadcrumb-${index}`}
              variant="rounded"
              width={index === breadcrumbsCount - 1 ? 140 : 88}
              height={16}
              sx={{ borderRadius: 1 }}
            />
          ))}
        </Box>
      )}

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={hasBreadcrumbs ? 1 : 0}
        height="40px"
      >
        <Skeleton variant="rounded" width="38%" height={24} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rounded" width={132} height={24} sx={{ borderRadius: 1 }} />
      </Box>

      {hasTabs && <PageTabsSkeleton count={tabsCount} />}
    </PageToolbar>
  );
}
